// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__mprmK","checkboxLabel":"Checkbox_checkboxLabel__hkJWB","title":"Checkbox_title__UDYms"};